/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// import p from 'polyglot/polyglot';

import { storage } from 'utils/storage';

window.ksting = {
  ...window.ksting,
  google: {
    clientId:
      '788217710013-5vimid5ptopjpa99v57h36c8bh6i79ra.apps.googleusercontent.com',
  },
};

// Y38aZ1Iwh4_DZIYztfKr8gvf

// window.addEventListener('message', event => {
//   console.log('some message', event.data);
// });

const { google } = window.ksting;
// const { google, locale } = window.ksting;
// const localeSuffix = location.pathname.indexOf(locale) < 0 ? '' : `/${locale}`;

let auth2 = null;

/**
 * Init google, create script tag if none exist, or resolve directly.
 *
 * @return {Promise}
 */
const init = () =>
  new Promise((resolve, reject) => {
    if (typeof window.gapi === 'undefined') {
      window.gAsyncInit = () => {
        window.gapi.load('client:auth2', () => {
          window.gapi.client
            .init({
              client_id: google.clientId,
              scope: 'profile email',
            })
            .then(() => {
              auth2 = window.gapi.auth2.getAuthInstance();
              resolve();
            })
            .catch(err => {
              reject(err);
            });
        });
      };

      ((d, s, id) => {
        let js = null;
        const gjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = 'https://apis.google.com/js/api:client.js';
        js.setAttribute(
          'onload',
          'this.onload=function(){};window.gAsyncInit();'
        );
        js.setAttribute(
          'onreadystatechange',
          "if (this.readyState === 'complete') this.onload()"
        );
        gjs.parentNode.insertBefore(js, gjs);
      })(document, 'script', 'google-jssdk');
    } else {
      resolve();
    }
  });

/**
 * Get google user details, if logged in.
 *
 * @return {Promise}
 */
const getUserDetails = () =>
  new Promise((resolve, reject) => {
    if (!auth2) {
      auth2 = window.gapi.auth2.getAuthInstance();
    }

    if (!auth2 || !auth2.isSignedIn.get()) {
      return reject('Not logged in');
    }

    resolve(auth2.currentUser.get());
  });

/**
 * Log in user via google.
 *
 * @return {Promise}
 */
const auth = () =>
  new Promise((resolve, reject) => {
    if (!auth2) {
      auth2 = window.gapi.auth2.getAuthInstance();
    }

    auth2
      .signIn()
      .then(user => {
        // console.log('--------- GOOGLE AUTH ---------');
        // console.log(user);
        // console.log('token -> ', user.getAuthResponse().id_token);
        // const basicProfile = user.getBasicProfile();
        // console.log('basicProfile: ', basicProfile);
        // console.log('Id: ', basicProfile.getId());
        // console.log('Name: ', basicProfile.getName());
        // console.log('GivenName: ', basicProfile.getGivenName());
        // console.log('FamilyName: ', basicProfile.getFamilyName());
        // console.log('ImageUrl: ', basicProfile.getImageUrl());
        // console.log('Email: ', basicProfile.getEmail());
        // console.log('------------------------------');
        // resolve(user);

        const basicProfile = user.getBasicProfile();

        storage.write('google_token', user.getAuthResponse().id_token);
        storage.write('google_login_id', basicProfile.getId());

        const response = {
          google_token: user.getAuthResponse().id_token,
          google_login_id: basicProfile.getId(),
          name: basicProfile.getName(),
          email: basicProfile.getEmail(),
          picture: basicProfile.getImageUrl(),
        };

        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });

/**
 * Handle google actions differently depending on action type.
 *
 * @param {string} type
 *
 * @return {Promise}
 */
function callGoogle(type) {
  switch (type) {
    case 'init':
      return init();

    case 'auth':
      return init()
        .then(auth, err => {
          throw err;
        })
        .catch(err => Promise.reject(err));

    case 'refresh':
      return init()
        .then(getUserDetails, err => {
          throw err;
        })
        .catch(err => Promise.reject(err));

    default:
      return new Promise((resolve, reject) =>
        reject('No such google request.')
      );
  }
}

/**
 * GOOGLE symbol
 *
 * @type {Symbol}
 */
export const GOOGLE = Symbol('GOOGLE');

/**
 * Google middleware, wraps action with google requests. Subsequently triggers actions
 * corresponding to the types passed with the initial action.
 *
 * @return {Promise}
 */
export default () => next => action => {
  const actionData = action[GOOGLE];

  // Prevent middleware from going past this point if not GOOGLE is specified.
  if (typeof actionData === 'undefined') {
    return next(action);
  }

  const { type, types, data } = actionData;
  const [requestType, successType, failureType] = types;

  next({ type: requestType });

  return callGoogle(type, data).then(
    response =>
      next({
        type: successType,
        payload: response,
      }),
    errors =>
      next({
        type: failureType,
        payload: errors || 'There was an error.',
      })
  );
};
